$(".tab-list-items").on( "click", function(e) { 
 e.preventDefault();
  if($(this).hasClass("tab-active")){

  }else{

    $(this).parent("ul").find(".tab-active").removeClass("tab-active")
    $(this).addClass("tab-active")
    var target = $(this).find("a").attr("href").substr(1)
    $(this).closest(".image-with-tab__content").find(".tab-tab-content").find(".tab-content").addClass("tab-hidden")
    $(this).closest(".image-with-tab__content").find(".tab-tab-content").find("#"+target).removeClass("tab-hidden")
  }
})

//CHANGE IMAGES IN GALLERY AND SLIDER DEPENDING ON SELECTED VARIANT

$("form[data-hide='true-extra']").on( "change", function() {  
  var chosenColor = $(".product-form__input input[type='radio']:checked").val() 
  $(".product__media-item.grid__item").each(function() {    
    if( $(this).attr("thumbnail-alt") == chosenColor ){       
      $(this).css("display", "block")
    }else{
      $(this).css("display", "none")
    }
  })   
} );



$("form[data-hide='true']").on( "change", function() { 
  var chosenColor = $(".product-form__input input[type='radio']:checked").val() 
      
  $(".product__media-item").each(function() {          
      if($(this).attr("thumbnail-alt") == chosenColor ){                 
        $(this).addClass("selected")
      }else{
        $(this).removeClass("selected")
      }         
  });
  
  $(".thumbnail-list__item").each(function() {
    if($(this).attr("thumbnail-alt") == chosenColor ){              
      $(this).css("display", "block")
    }else{
      $(this).css("display", "none")
    }
  }) 

});


$(document).ready(function() {
if($(".thumbnail-list" ).length > 0){
  function disableButton(){    
      clearTimeout($.data(this, 'scrollTimer'));
      $.data(this, 'scrollTimer', setTimeout(function() { 
      var ulWidth = $(".thumbnail-list").outerWidth()
      
      var uloffsetLeft = $(".thumbnail-list").offset().left
      var uloffsetRight = $(".thumbnail-list").offset().left + ulWidth
      var slide = $(".thumbnail-list__item:visible")
      var liCount = $(".thumbnail-list__item:visible").length-1
      var firstSlide = slide.eq(0)
      var lastSlide = slide.eq(10)      
      var firstSlideOffsetLeft = slide.eq(0).offset().left
      var lastSlideOffsetRight = slide.eq(liCount).offset().left         
      if(firstSlideOffsetLeft >= uloffsetLeft ){       
          $(".slider-button--prev").prop('disabled', 'disabled')  
      }else{ 
        $(".slider-button--prev").prop("disabled", false)
      }
      if(lastSlideOffsetRight <= uloffsetRight ){ 
          $(".slider-button--next").prop('disabled', 'disabled')  
      }else{
        $(".slider-button--next").prop("disabled", false)
      }      
        }, 250));       
    } 
    disableButton()    
  
    $("body").on("click", ".custom_swatch", function(){
      disableButton() 
    })  
    $(".thumbnail-list" ).on( "scroll", function() {
      disableButton()    
    })
}

})


function detectTouchscreen() {
  var result = false;
  if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
    // if Pointer Events are supported, just check maxTouchPoints
    if (navigator.maxTouchPoints > 0) {
      result = true;
    }
  } else {
    // no Pointer Events...
    if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
      // check for any-pointer:coarse which mostly means touchscreen
      result = true;
    } else if (window.TouchEvent || ('ontouchstart' in window)) {
      // last resort - check for exposed touch events API / event handler
      result = true;
    }
  }
  return result;
}
var isTouch = detectTouchscreen()
if(isTouch == true){
 $('body').addClass('touch-enabled')
}else{
  $('body').removeClass('touch-enabled')
}
